import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import moment from 'moment';
import ReactTable from 'react-table';
import axios from 'axios';
import { DateRangePicker } from 'react-dates';
import Select from 'react-select';
import Creatable from 'react-select/lib/Creatable';
import makeAnimated from 'react-select/lib/animated';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import { Configurations } from '../../../Utils/Configurations';

const createInitialFilters = () => ({
    inicio: {
        startDate: null,
        endDate: null,
        focusedInput: null,
    },
    statusList: [],
    shippingCompanyList: [],
    planList: [],
    paymentMethodList: [],
    coordinationList: [],
    nomeSolicitante: [],
});

const SubscriptionCileList = (props) => {
    const [listaAssinaturas, setListaAssinaturas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPaginas, setTotalPaginas] = useState(0);
    const [modalEndereco, setModalEndereco] = useState(false);
    const [selectedEndereco, setSelectedEndereco] = useState(null);
    const [openFilters, setOpenFilters] = useState(true);
    const [filters, setFilters] = useState(createInitialFilters);
    const [listaIdAssinatura, setListaIdAssinatura] = useState([]);
    const [listaCiclo, setListaCiclo] = useState([]);
    const [hasSearched, setHasSearched] = useState(true);
    const [idAssinaturaInput, setIdAssinaturaInput] = useState('');
    const [solicitanteInput, setSolicitanteInput] = useState('');
    const [cicloInput, setCicloInput] = useState('');
    const [tipoBuscaId, setTipoBuscaId] = useState('idAssinatura');

    const animatedComponents = useMemo(() => makeAnimated(), []);
    const creatableComponents = useMemo(() => ({
        ...animatedComponents,
        DropdownIndicator: null,
        IndicatorSeparator: null,
    }), [animatedComponents]);
    const phrases = useMemo(() => ({
        closeDatePicker: "Fechar",
        clearDates: "Limpar datas",
        calendarLabel: "Calendário"
    }), []);

    const statusOptions = useMemo(() => ([
        { value: '0', label: 'Inativa' },
        { value: '1', label: 'Ativa' },
        { value: '2', label: 'Inadimplente' },
        { value: '3', label: 'Pausada' },
    ]), []);

    const shippingCompanyOptions = useMemo(() => ([
        { value: 'PAC - melhor envio', label: 'PAC - melhor envio' },
        { value: 'SEDEX - melhor envio', label: 'SEDEX - melhor envio' },
        { value: 'Loggi', label: 'Loggi' },
        { value: 'Correios', label: 'Correios' },
        { value: 'JADLOG', label: 'JADLOG' },
        { value: 'CARGO', label: 'CARGO' },
        { value: 'SEDEX - Correios', label: 'SEDEX - Correios' },
        { value: 'SPDL', label: 'SPDL' }
    ]), []);

    const planOptions = useMemo(() => ([
        { value: 'Ouro', label: 'Ouro' },
        { value: 'Diamante', label: 'Diamante' },
        { value: 'Esmeralda', label: 'Esmeralda' },
        { value: 'Digital Individual Mensal', label: 'Digital Individual Mensal' },
        { value: 'Digital Individual Trimestral', label: 'Digital Individual Trimestral' },
        { value: 'Digital Individual Semestral', label: 'Digital Individual Semestral' },
        { value: 'Digital Individual Anual', label: 'Digital Individual Anual' },
        { value: 'Digital DUO Mensal', label: 'Digital DUO Mensal' },
        { value: 'Digital DUO Trimestral', label: 'Digital DUO Trimestral' },
        { value: 'Digital DUO Semestral', label: 'Digital DUO Semestral' },
        { value: 'Digital DUO Anual', label: 'Digital DUO Anual' },
        { value: 'Digital PREMIUM Mensal', label: 'Digital PREMIUM Mensal' },
        { value: 'Digital PREMIUM Trimestral', label: 'Digital PREMIUM Trimestral' },
        { value: 'Digital PREMIUM Semestral', label: 'Digital PREMIUM Semestral' },
        { value: 'Digital PREMIUM Anual', label: 'Digital PREMIUM Anual' }
    ]), []);

    const paymentMethodOptions = useMemo(() => ([
        { value: 'Boleto', label: 'Boleto Bancário' },
        { value: 'Pix', label: 'Pix' },
        { value: 'Cartão de Crédito', label: 'Cartão de Crédito' }
    ]), []);

    const coordinationOptions = useMemo(() => ([
        { value: 'CNSP', label: 'CNSP' },
        { value: 'CCLP', label: 'CCLP' },
        { value: 'CNOP', label: 'CNOP' },
        { value: 'CGSP', label: 'CGSP' },
        { value: 'CLP', label: 'CLP' },
        { value: 'CRO', label: 'CRO' },
        { value: 'CRC', label: 'CRC' },
        { value: 'CRMRJ', label: 'CRMRJ' },
        { value: 'CBSF', label: 'CBSF' },
        { value: 'CRE Sul', label: 'CRE Sul' },
        { value: 'CRE Oeste', label: 'CRE Oeste' },
        { value: 'CRE Paraná', label: 'CRE Paraná' },
        { value: 'CRE Leste', label: 'CRE Leste' }
    ]), []);

    // Usado pela coluna "Endereço" (atualmente desativada). Reativar junto com a coluna.
    // const abrirModalEndereco = useCallback((endereco) => {
    //     setSelectedEndereco(endereco || null);
    //     setModalEndereco(true);
    // }, []);

    const fecharModalEndereco = useCallback(() => {
        setModalEndereco(false);
        setSelectedEndereco(null);
    }, []);

    const toggleFilters = useCallback(() => {
        setOpenFilters((prevState) => !prevState);
    }, []);

    const isOutsideRange = useCallback((day) => {
        return day.format("YYYY-MM-DD") > moment().format("YYYY-MM-DD");
    }, []);

    const onInicioFocusChange = useCallback((focusedInput) => {
        setFilters((prevState) => ({
            ...prevState,
            inicio: {
                ...prevState.inicio,
                focusedInput,
            }
        }));
    }, []);

    const onInicioDatesChange = useCallback(({ startDate, endDate }) => {
        setFilters((prevState) => {
            const inicioAtualizado = {
                ...prevState.inicio,
                startDate,
                endDate,
            };

            if (startDate) inicioAtualizado.gte = startDate.format('YYYY-MM-DD');
            else delete inicioAtualizado.gte;

            if (endDate) inicioAtualizado.lte = endDate.format('YYYY-MM-DD');
            else delete inicioAtualizado.lte;

            return {
                ...prevState,
                inicio: inicioAtualizado,
            };
        });
    }, []);

    const handleSelectChange = useCallback((selectedOptions, actionMeta) => {
        const name = actionMeta && actionMeta.name;
        if (!name) {
            return;
        }
        setFilters((prevState) => ({
            ...prevState,
            [name]: selectedOptions || [],
        }));
    }, []);

    const addSolicitanteValue = useCallback((value) => {
        const trimmedValue = (value || '').trim();
        if (!trimmedValue) {
            return;
        }
        setFilters((prevState) => {
            const currentList = prevState.nomeSolicitante || [];
            const alreadyExists = currentList.some((item) => {
                const itemValue = (item && item.value ? item.value : '').toLowerCase();
                return itemValue === trimmedValue.toLowerCase();
            });
            if (alreadyExists) {
                return prevState;
            }
            return {
                ...prevState,
                nomeSolicitante: [
                    ...currentList,
                    { value: trimmedValue, label: trimmedValue }
                ]
            };
        });
        setSolicitanteInput('');
    }, []);

    const handleSolicitanteInputChange = useCallback((value, actionMeta) => {
        if (actionMeta && actionMeta.action === 'input-change') {
            setSolicitanteInput(value);
        }
        return value;
    }, []);

    const handleSolicitanteKeyDown = useCallback((event) => {
        if (!solicitanteInput) {
            return;
        }
        if (event.key === 'Enter' || event.key === 'Tab') {
            event.preventDefault();
            addSolicitanteValue(solicitanteInput);
        }
    }, [solicitanteInput, addSolicitanteValue]);

    const handleSolicitanteBlur = useCallback(() => {
        if (solicitanteInput) {
            addSolicitanteValue(solicitanteInput);
        }
    }, [solicitanteInput, addSolicitanteValue]);

    const addIdAssinaturaValue = useCallback((value) => {
        const trimmedValue = (value || '').trim();
        if (!trimmedValue) {
            return;
        }
        setListaIdAssinatura((prevState) => {
            const currentList = prevState || [];
            const alreadyExists = currentList.some((item) => {
                const itemValue = (item && item.value ? item.value : '').toLowerCase();
                return itemValue === trimmedValue.toLowerCase();
            });
            if (alreadyExists) {
                return prevState;
            }
            return [
                ...currentList,
                { value: trimmedValue, label: trimmedValue }
            ];
        });
        setIdAssinaturaInput('');
    }, []);

    const handleIdAssinaturaInputChange = useCallback((value, actionMeta) => {
        if (actionMeta && actionMeta.action === 'input-change') {
            setIdAssinaturaInput(value);
        }
        return value;
    }, []);

    const handleIdAssinaturaKeyDown = useCallback((event) => {
        if (!idAssinaturaInput) {
            return;
        }
        if (event.key === 'Enter' || event.key === 'Tab') {
            event.preventDefault();
            addIdAssinaturaValue(idAssinaturaInput);
        }
    }, [idAssinaturaInput, addIdAssinaturaValue]);

    const handleIdAssinaturaBlur = useCallback(() => {
        if (idAssinaturaInput) {
            addIdAssinaturaValue(idAssinaturaInput);
        }
    }, [idAssinaturaInput, addIdAssinaturaValue]);

    const handleIdAssinaturaChange = useCallback((selectedOptions) => {
        setListaIdAssinatura(selectedOptions || []);
    }, []);

    const handleTipoBuscaIdChange = useCallback((e) => {
        setTipoBuscaId(e.target.value);
    }, []);

    const addCicloValue = useCallback((value) => {
        const trimmedValue = (value || '').trim();
        if (!trimmedValue) {
            return;
        }
        setListaCiclo((prevState) => {
            const currentList = prevState || [];
            const alreadyExists = currentList.some((item) => {
                const itemValue = (item && item.value ? item.value : '').toLowerCase();
                return itemValue === trimmedValue.toLowerCase();
            });
            if (alreadyExists) {
                return prevState;
            }
            return [
                ...currentList,
                { value: trimmedValue, label: trimmedValue }
            ];
        });
        setCicloInput('');
    }, []);

    const handleCicloInputChange = useCallback((value, actionMeta) => {
        if (actionMeta && actionMeta.action === 'input-change') {
            setCicloInput(value);
        }
        return value;
    }, []);

    const handleCicloKeyDown = useCallback((event) => {
        if (!cicloInput) {
            return;
        }
        if (event.key === 'Enter' || event.key === 'Tab') {
            event.preventDefault();
            addCicloValue(cicloInput);
        }
    }, [cicloInput, addCicloValue]);

    const handleCicloBlur = useCallback(() => {
        if (cicloInput) {
            addCicloValue(cicloInput);
        }
    }, [cicloInput, addCicloValue]);

    const handleCicloChange = useCallback((selectedOptions) => {
        setListaCiclo(selectedOptions || []);
    }, []);

    const chamadaAssinaturas = (pageParam, pageSizeParam) => {
        setLoading(true);

        const config = new Configurations();
        const paginaAtual = pageParam !== undefined && pageParam !== null ? pageParam : page;
        const tamanhoPagina = pageSizeParam !== undefined && pageSizeParam !== null ? pageSizeParam : pageSize;
        const dtInicio = filters.inicio && filters.inicio.gte ? filters.inicio.gte : '';
        const dtFim = filters.inicio && filters.inicio.lte ? filters.inicio.lte : '';
        const idStatus = (filters.statusList || []).map(item => item.value).filter(Boolean).join(',');
        const transportadora = (filters.shippingCompanyList || []).map(item => item.value).filter(Boolean).join(',');
        const plano = (filters.planList || []).map(item => item.value).filter(Boolean).join(',');
        const tipoPagamento = (filters.paymentMethodList || []).map(item => item.value).filter(Boolean).join(',');
        const coord = (filters.coordinationList || []).map(item => item.value).filter(Boolean).join(',');
        const idAssinatura = (listaIdAssinatura || []).map(item => item.value).filter(Boolean).join(',');
        const ciclo = (listaCiclo || []).map(item => item.value).filter(Boolean).join(',');
        const solicitante = (filters.nomeSolicitante || []).map(item => item.value).filter(Boolean).join(',');

        let url = `/assinaturas-cile/lista?pagina=${paginaAtual}&limite=${tamanhoPagina}`;

        if (dtInicio) {
            url += `&dtInicio=${dtInicio}`;
        }

        if (dtFim) {
            url += `&dtFim=${dtFim}`;
        }

        if (idStatus) {
            url += `&idStatus=${idStatus}`;
        }

        if (transportadora) {
            url += `&transportadora=${transportadora}`;
        }

        if (plano) {
            url += `&plano=${plano}`;
        }

        if (tipoPagamento) {
            url += `&tipoPagamento=${tipoPagamento}`;
        }

        if (coord) {
            url += `&coord=${coord}`;
        }

        if (idAssinatura) {
            const param = tipoBuscaId === 'idExterno' ? 'idExterno' : 'idAssinatura';
            url += `&${param}=${idAssinatura}`;
        }

        if (ciclo) {
            url += `&ciclo=${ciclo}`;
        }

        if (solicitante) {
            url += `&solicitante=${solicitante}`;
        }

        axios.get(
            config.apiBasePath +
            url
        )
            .then(response => {
                setListaAssinaturas(response.data.data || []);
                if (response.data && response.data.pagination && response.data.pagination.totalPages !== undefined) {
                    setTotalPaginas(response.data.pagination.totalPages);
                }
            })
            .catch(err => {
                console.log("ERROR: ", err)
            })
            .finally(() => {
                setLoading(false);
            });
    };

    // Mantém a referência sempre atualizada para a última versão de chamadaAssinaturas,
    // permitindo chamá-la sem incluí-la nas dependências dos hooks (evita disparar a
    // busca automaticamente quando os filtros mudam).
    const chamadaAssinaturasRef = useRef(chamadaAssinaturas);
    chamadaAssinaturasRef.current = chamadaAssinaturas;

    const filterSearch = useCallback((e) => {
        e.preventDefault();

        if (!hasSearched) {
            setHasSearched(true);
            if (page !== 1) {
                setPage(1);
            }
            return;
        }

        if (page !== 1) {
            setPage(1);
            return;
        }

        chamadaAssinaturasRef.current(1, pageSize);
    }, [page, pageSize, hasSearched]);

    const columns = useMemo(() => [
        {
            Header: 'ID Interno',
            accessor: 'id',
            className: 'text-center pointer',
            width: 90,
        },
        {
            Header: 'ID Betalabs',
            accessor: 'idExterno',
            className: 'text-center pointer',
            width: 110,
        },
        {
            Header: 'Nome do Solicitante',
            accessor: 'nomeSolicitante',
            className: 'text-center pointer',
            width: 280
        },
        {
            Header: 'Status',
            accessor: 'status',
            className: 'text-center pointer',
            width: 140,
            Cell: row => {
                return row.value ? <span className={`badge badge-${badgeColor(row.value)}`}>{row.value}</span> : <span className={`badge badge-secondary`}>Inativa</span>;
            }
        },
        {
            Header: 'Plano',
            accessor: 'plano',
            className: 'text-center pointer',
            width: 240,
            Cell: row => {
                return row.value ? <span className={`badge badge-${badgePlano(row.value)}`}>{row.value}</span> : "-"
            }
        },
        {
            Header: 'Forma de Pagamento',
            accessor: 'formaPagamento',
            className: 'text-center pointer',
            width: 180,
            Cell: row => {
                return row.value ? <span className={`badge badge-${badgePagamento(row.value)}`}>{row.value}</span> : "-"
            }
        },
        {
            Header: 'Início',
            accessor: 'inicio',
            className: 'text-center pointer',
            width: 140,
            Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YY HH:mm")}</span> : <span>-</span>)
        },
        {
            Header: 'Ciclo Atual',
            accessor: 'cicloAtual',
            className: 'text-center pointer',
            width: 110,
        },
        {
            Header: 'Transportadora',
            accessor: 'idTransportadora',
            className: 'text-center pointer',
            width: 140,
            Cell: row => transportadoraLabel(row.value)
        },
        {
            Header: 'Coord.',
            accessor: 'coordenadoria',
            className: 'text-center pointer',
            width: 120,
        },
        // {
        //     Header: 'Endereço',
        //     accessor: 'endereco',
        //     className: 'text-center pointer',
        //     width: 160,
        //     Cell: row => {
        //         return (
        //             <button
        //                 type="button"
        //                 className="btn btn-outline-primary btn-sm"
        //                 onClick={(e) => {
        //                     e.stopPropagation();
        //                     abrirModalEndereco(row.original.endereco);
        //                 }}
        //             >
        //                 Exibir endereço
        //             </button>
        //         )
        //     }
        // },
    ], []);

    const selecionaAssinatura = (_idAssinatura) => {
        props.history.push({ pathname: `/cile/assinaturas/detalhes/${_idAssinatura}` });
    }

    const onPageChange = pageIndex => {
        setPage(pageIndex + 1);
    };

    const onPageSizeChange = (pageSize, pageIndex) => {
        setPageSize(pageSize);
        setPage(pageIndex + 1);
    };

    const enderecoSelecionado = selectedEndereco || {};

    const badgeColor = (badge) => {
        switch (badge) {
            case 'Ativa':
                return 'success';
            case 'Processando':
                return 'warning';
            case 'Inativa':
                return 'secondary';
            default:
                return 'primary';
        }
    }

    const badgePagamento = (badge) => {
        switch (badge) {
            case 'PIX':
                return 'success';
            case 'Cartão de Crédito':
                return 'info';
            case 'Boleto Bancario':
                return 'primary';
            default:
                return 'primary';
        }
    }

    const badgePlano = (badge) => {
        switch (badge) {
            case 'Ouro':
            case 'Diamante':
            case 'Esmeralda':
                return 'purple';

            default:
                return 'orange';
        }
    }

    const transportadoraLabel = (id) => {
        switch (id) {
            case 3:
                return 'Correios';
            case 7:
                return 'SPDL';
            case 9:
                return 'JADLOG';
            case 10:
                return 'CARGO';
            case 11:
                return 'SEDEX - Melhor Envio';
            case 12:
                return 'SEDEX - Correios';
            case 13:
                return 'PAC - Melhor Envio';
            case 14:
                return 'Loggi';
            default:
                return '-';
        }
    }

    useEffect(() => {
        if (!hasSearched) {
            return;
        }

        chamadaAssinaturasRef.current(page, pageSize);
    }, [page, pageSize, hasSearched]);

    return (
        <div className="row edition-list">
            <div className="col-12">
                <div className="row no-gutters align-items-center">
                    <div className="col-12 col-lg-8 text-center text-lg-left">
                        <h2 className="title-1">CILE - Assinaturas</h2>
                    </div>
                    <div className="col-12 col-lg-4 text-center text-lg-right">
                        <div className="row no-gutters">
                            {/* <div className="col py-2 py-lg-0">
                                <button className="btn btn-outline-info mx-2" type="button" name="novoProduto" onClick={() => props.history.push({ pathname: '/cile/produtos/detalhes/novo-produto' })}>
                                    Cadastrar novo produto
                                </button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <div className="card">
                    <div className="card-header p-2" id="headingOne">
                        <div className="col-12">
                            <button className="btn btn-link w-100 text-left" type="button" onClick={toggleFilters}>
                                <i className={`fa mr-2 ${openFilters ? "fa-chevron-right" : "fa-chevron-down"}`}></i>
                                Filtros
                            </button>
                        </div>
                    </div>
                    <div className={`card-body ${!openFilters && "collapse"}`} id="boxFilters">
                        <form onSubmit={filterSearch} noValidate>
                            <div className="row">
                                <div className="col-4">
                                    <div className="form-group">
                                        <label htmlFor="dpInicioStartDate">Período de início</label><br />
                                        <DateRangePicker
                                            showClearDates
                                            enableOutsideDays
                                            isOutsideRange={isOutsideRange}
                                            startDate={filters.inicio.startDate}
                                            startDateId="dpInicioStartDate"
                                            endDate={filters.inicio.endDate}
                                            endDateId="dpInicioEndDate"
                                            onDatesChange={onInicioDatesChange}
                                            focusedInput={filters.inicio.focusedInput}
                                            onFocusChange={onInicioFocusChange}
                                            displayFormat="DD/MM/YYYY"
                                            startDatePlaceholderText="Data inicial"
                                            endDatePlaceholderText="Data final"
                                            phrases={phrases}
                                            minimumNights={0}
                                        />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label htmlFor="ddlStatusAssinatura">Status</label>
                                        <Select
                                            id="ddlStatusAssinatura"
                                            placeholder="Selecione um status"
                                            closeMenuOnSelect={true}
                                            components={animatedComponents}
                                            value={filters.statusList}
                                            isMulti
                                            name="statusList"
                                            onChange={handleSelectChange}
                                            options={statusOptions}
                                        />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label htmlFor="ddlTransportadora">Transportadora</label>
                                        <Select
                                            id="ddlTransportadora"
                                            placeholder="Selecione uma transportadora"
                                            closeMenuOnSelect={true}
                                            components={animatedComponents}
                                            value={filters.shippingCompanyList}
                                            isMulti
                                            name="shippingCompanyList"
                                            onChange={handleSelectChange}
                                            options={shippingCompanyOptions}
                                        />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label htmlFor="ddlPlano">Plano</label>
                                        <Select
                                            id="ddlPlano"
                                            placeholder="Selecione um plano"
                                            closeMenuOnSelect={true}
                                            components={animatedComponents}
                                            value={filters.planList}
                                            isMulti
                                            name="planList"
                                            onChange={handleSelectChange}
                                            options={planOptions}
                                        />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label htmlFor="ddlFormaPagamento">Forma de Pagamento</label>
                                        <Select
                                            id="ddlFormaPagamento"
                                            placeholder="Selecione uma forma de pagamento"
                                            closeMenuOnSelect={true}
                                            components={animatedComponents}
                                            value={filters.paymentMethodList}
                                            isMulti
                                            name="paymentMethodList"
                                            onChange={handleSelectChange}
                                            options={paymentMethodOptions}
                                        />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label htmlFor="ddlCoordenadoria">Coordenadoria</label>
                                        <Select
                                            id="ddlCoordenadoria"
                                            placeholder="Selecione uma coordenadoria"
                                            closeMenuOnSelect={true}
                                            components={animatedComponents}
                                            value={filters.coordinationList}
                                            isMulti
                                            name="coordinationList"
                                            onChange={handleSelectChange}
                                            options={coordinationOptions}
                                        />
                                    </div>
                                </div>
                                <div className="col-4 tags-pedido">
                                    <div className='d-flex justify-content-between align-items-center mb-1'>
                                        <label className='m-0'>Id assinatura</label>
                                        <div>
                                            <div className="form-check form-check-inline mt-1">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    id="tipoBuscaIdAssinatura"
                                                    name="tipoBuscaId"
                                                    value="idAssinatura"
                                                    checked={tipoBuscaId === 'idAssinatura'}
                                                    onChange={handleTipoBuscaIdChange}
                                                />
                                                <label className="form-check-label" htmlFor="tipoBuscaIdAssinatura">ID Interno</label>
                                            </div>
                                            <div className="form-check form-check-inline mt-1">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    id="tipoBuscaIdExterno"
                                                    name="tipoBuscaId"
                                                    value="idExterno"
                                                    checked={tipoBuscaId === 'idExterno'}
                                                    onChange={handleTipoBuscaIdChange}
                                                />
                                                <label className="form-check-label" htmlFor="tipoBuscaIdExterno">ID Betalabs</label>
                                            </div>
                                        </div>
                                    </div>
                                    <Creatable
                                        id="ddlIdAssinatura"
                                        placeholder="Digite o ID da assinatura"
                                        closeMenuOnSelect={true}
                                        components={creatableComponents}
                                        value={listaIdAssinatura}
                                        isMulti
                                        name="idAssinatura"
                                        onChange={handleIdAssinaturaChange}
                                        onInputChange={handleIdAssinaturaInputChange}
                                        inputValue={idAssinaturaInput}
                                        onKeyDown={handleIdAssinaturaKeyDown}
                                        onBlur={handleIdAssinaturaBlur}
                                        menuIsOpen={false}
                                    />
                                    <small>Insira o ID e pressione "Enter" ou "Tab".</small>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label htmlFor="ddlSolicitante">Nome do solicitante</label>
                                        <Creatable
                                            id="ddlSolicitante"
                                            placeholder="Digite o nome de um solicitante"
                                            closeMenuOnSelect={true}
                                            components={creatableComponents}
                                            value={filters.nomeSolicitante}
                                            isMulti
                                            name="nomeSolicitante"
                                            onChange={handleSelectChange}
                                            onInputChange={handleSolicitanteInputChange}
                                            inputValue={solicitanteInput}
                                            onKeyDown={handleSolicitanteKeyDown}
                                            onBlur={handleSolicitanteBlur}
                                            menuIsOpen={false}
                                        />
                                        <small>Insira o nome(s) do(s) solicitante(s) e pressione "Enter" ou "Tab".</small>
                                    </div>
                                </div>
                                <div className="col-4 tags-pedido">
                                    <label>Ciclo</label>
                                    <Creatable
                                        id="ddlCiclo"
                                        placeholder="Digite o ciclo"
                                        closeMenuOnSelect={true}
                                        components={creatableComponents}
                                        value={listaCiclo}
                                        isMulti
                                        name="ciclo"
                                        onChange={handleCicloChange}
                                        onInputChange={handleCicloInputChange}
                                        inputValue={cicloInput}
                                        onKeyDown={handleCicloKeyDown}
                                        onBlur={handleCicloBlur}
                                        menuIsOpen={false}
                                    />
                                    <small>Insira o(s) ciclo(s) e pressione "Enter" ou "Tab".</small>
                                </div>
                                <div className="col-12 text-right">
                                    <button className="btn btn-primary">Buscar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="col-12 mt-3">
                {loading ? (
                    <div className="row no-gutters">
                        <div className="col-12 text-center py-5">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                    </div>
                ) : (
                    <div className="row no-gutters">
                        <div className="col-12">
                            <div className="row no-gutters">
                                <div className="col-12 text-center text-lg-left">
                                    <p className="py-2 m-0">Clique na assinatura para obter mais informações.</p>
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <ReactTable
                                                data={listaAssinaturas}
                                                columns={columns}
                                                manual
                                                pages={totalPaginas}
                                                page={page - 1}
                                                pageSize={pageSize}
                                                onPageChange={onPageChange}
                                                onPageSizeChange={onPageSizeChange}
                                                defaultPageSize={10}
                                                className="-striped -highlight"
                                                headerClassName="ebs-table-header"
                                                previousText='Anterior'
                                                nextText='Próximo'
                                                loadingText='Carregando...'
                                                noDataText='Nenhuma assinatura encontrada.'
                                                pageText='Página'
                                                ofText='de'
                                                rowsText='linhas'
                                                loading={loading}
                                                getTdProps={(state, rowInfo, column, instance) => {
                                                    return {
                                                        onClick: (e, handleOriginal) => {
                                                            if (rowInfo) {
                                                                if (column.Header === "Endereço") handleOriginal && handleOriginal();
                                                                else selecionaAssinatura(rowInfo.original.id)
                                                            }
                                                        }
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Modal isOpen={modalEndereco} toggle={fecharModalEndereco}>
                <ModalHeader toggle={fecharModalEndereco}>
                    Endereço da assinatura
                </ModalHeader>
                <ModalBody>
                    <p className="mb-2"><strong>Nome:</strong> {enderecoSelecionado.nome || '-'}</p>
                    <p className="mb-2"><strong>Logradouro:</strong> {enderecoSelecionado.logradouro || '-'}, {enderecoSelecionado.numero || '-'}</p>
                    <p className="mb-2"><strong>Complemento:</strong> {enderecoSelecionado.complemento || '-'}</p>
                    <p className="mb-2"><strong>Bairro:</strong> {enderecoSelecionado.bairro || '-'}</p>
                    <p className="mb-2"><strong>Cidade:</strong> {enderecoSelecionado.cidade || '-'}</p>
                    <p className="mb-2"><strong>UF:</strong> {enderecoSelecionado.uf || '-'}</p>
                    <p className="mb-0"><strong>CEP:</strong> {enderecoSelecionado.cep || '-'}</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={fecharModalEndereco}>Fechar</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default SubscriptionCileList;